import { Store } from 'pullstate';

const EnvironmentStore = new Store({});

export const initialize = (store, environment) => {
  Object.keys(environment).forEach(key => {
    store[key] = environment[key].toString();
  });
};

export default EnvironmentStore;
